export const GET_INVENTORY_STARTED = "GET_INVENTORY_STARTED"
export const GET_INVENTORY_SUCCESS = "GET_INVENTORY_SUCCESS"
export const GET_INVENTORY_FAILURE = "GET_INVENTORY_FAILURE"

export const CREATE_PRODUCT_CATEGORY_STARTED = "CREATE_PRODUCT_CATEGORY_STARTED"
export const CREATE_PRODUCT_CATEGORY_SUCCESS = "CREATE_PRODUCT_CATEGORY_SUCCESS"
export const CREATE_PRODUCT_CATEGORY_FAILURE = "CREATE_PRODUCT_CATEGORY_FAILURE"

export const UPDATE_PRODUCT_CATEGORY_STARTED = "UPDATE_PRODUCT_CATEGORY_STARTED"
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = "UPDATE_PRODUCT_CATEGORY_SUCCESS"
export const UPDATE_PRODUCT_CATEGORY_FAILURE = "UPDATE_PRODUCT_CATEGORY_FAILURE"

export const DELETE_PRODUCT_CATEGORY_STARTED = "DELETE_PRODUCT_CATEGORY_STARTED"
export const DELETE_PRODUCT_CATEGORY_SUCCESS = "DELETE_PRODUCT_CATEGORY_SUCCESS"
export const DELETE_PRODUCT_CATEGORY_FAILURE = "DELETE_PRODUCT_CATEGORY_FAILURE"

export const UPDATE_PRODUCT_CATEGORY_ORDER_STARTED = "UPDATE_PRODUCT_CATEGORY_ORDER_STARTED"
export const UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS = "UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS"
export const UPDATE_PRODUCT_CATEGORY_ORDER_FAILURE = "UPDATE_PRODUCT_CATEGORY_ORDER_FAILURE"

export const UPDATE_PRODUCT_ORDER_STARTED = "UPDATE_PRODUCT_ORDER_STARTED"
export const UPDATE_PRODUCT_ORDER_SUCCESS = "UPDATE_PRODUCT_ORDER_SUCCESS"
export const UPDATE_PRODUCT_ORDER_FAILURE = "UPDATE_PRODUCT_ORDER_FAILURE"

export const GET_PRODUCT_DETAIL_STARTED = "GET_PRODUCT_DETAIL_STARTED"
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS"
export const GET_PRODUCT_DETAIL_FAILURE = "GET_PRODUCT_DETAIL_FAILURE"

export const CREATE_PRODUCT_STARTED = "CREATE_PRODUCT_STARTED"
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS"
export const CREATE_PRODUCT_FAILURE = "CREATE_PRODUCT_FAILURE"

export const UPDATE_PRODUCT_STARTED = "UPDATE_PRODUCT_STARTED"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE"

export const DELETE_PRODUCT_STARTED = "DELETE_PRODUCT_STARTED"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE"

export const ADJUST_PRODUCT_STOCK_STARTED = "ADJUST_PRODUCT_STOCK_STARTED"
export const ADJUST_PRODUCT_STOCK_SUCCESS = "ADJUST_PRODUCT_STOCK_SUCCESS"
export const ADJUST_PRODUCT_STOCK_FAILURE = "ADJUST_PRODUCT_STOCK_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"